module.exports = __webpack_public_path__ + "static/media/tramits.ddd5165f.svg";